export class ReportFilterBase {

}
